import { render, staticRenderFns } from "./AgreeTerms.vue?vue&type=template&id=19236995&scoped=true&"
import script from "./AgreeTerms.vue?vue&type=script&lang=js&"
export * from "./AgreeTerms.vue?vue&type=script&lang=js&"
import style0 from "./AgreeTerms.vue?vue&type=style&index=0&id=19236995&prod&lang=scss&scoped=true&"
import style1 from "./AgreeTerms.vue?vue&type=style&index=1&id=19236995&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19236995",
  null
  
)

export default component.exports